import { VueModule } from '@Foundation/utilities';
import ArticleSection from './code/Scripts/components/article-section';

export default VueModule({
  components: {
    ArticleSection
  }
});
